import React, { useState } from "react";

import { createContext } from "react";

export const CurrencyContext = React.createContext();

export const CurrencyProvider = (props) => {
  const [currency, setCurrency] = useState("inr");

  return (
    <CurrencyContext.Provider
      value={{ currencyState: [currency, setCurrency] }}
    >
      {props.children}
    </CurrencyContext.Provider>
  );
};
